import { styled } from '@material-ui/core/styles';

import Chip from '@material-ui/core/Chip';

const ChipStyled = styled(Chip)({
	height: 10,
});

export default Chip;
